/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Product Search API
 * Documentation of the controllers and endpoints used in the product-search-service.
 * OpenAPI spec version: deploy-only-BS-846-2821
 */
import type {
  CampaignDTO,
  ListerDTO,
  SearchForFredhopperCampaignsByUserLocationServer500,
  SearchForFredhopperCampaignsByUserLocationServerParams,
  SearchForFredhopperCampaignsServer500,
  SearchForFredhopperCampaignsServerParams,
  SearchForProducts500,
  SearchForProductsParams,
  SearchForProductsServer500,
  SearchForProductsServerParams,
} from '@as-react/common-types/product-search-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Search for campaigns
 */
export const searchForFredhopperCampaignsByUserLocationServer = (
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName = 'searchForFredhopperCampaignsByUserLocation',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<CampaignDTO>>(
    { url: `/campaign/search/userlocation`, method: 'GET', params, signal },
    { operationName: 'searchForFredhopperCampaignsByUserLocation', ...options }
  );
};

export const useSearchForFredhopperCampaignsByUserLocationServerQueryOptions = <
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>,
>(
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName = 'searchForFredhopperCampaignsByUserLocation',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/campaign/search/userlocation`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>> = ({
    signal,
  }) => searchForFredhopperCampaignsByUserLocationServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForFredhopperCampaignsByUserLocationServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>
>;
export type SearchForFredhopperCampaignsByUserLocationServerQueryError =
  ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>;

export function useSearchForFredhopperCampaignsByUserLocationServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>,
>(
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
          TError,
          Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForFredhopperCampaignsByUserLocationServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>,
>(
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
          TError,
          Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForFredhopperCampaignsByUserLocationServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>,
>(
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for campaigns
 */

export function useSearchForFredhopperCampaignsByUserLocationServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsByUserLocationServer500>,
>(
  params: SearchForFredhopperCampaignsByUserLocationServerParams,
  operationName = 'searchForFredhopperCampaignsByUserLocation',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsByUserLocationServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForFredhopperCampaignsByUserLocationServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search for products based on a search query
 */
export const useSearchForProductsHook = () => {
  const searchForProducts = useQueryFetch<ListerDTO>();

  return useCallback(
    (
      params: SearchForProductsParams,
      operationName = 'searchForProducts',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return searchForProducts(
        { url: `/api/aem/search`, method: 'GET', params, signal },
        { operationName: 'searchForProducts', ...options }
      );
    },
    [searchForProducts]
  );
};

export const useSearchForProductsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/search`, queryOptions });

  const searchForProducts = useSearchForProductsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>> = ({ signal }) =>
    searchForProducts(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForProductsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
>;
export type SearchForProductsQueryError = ErrorType<SearchForProducts500>;

export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for products based on a search query
 */

export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForProductsQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search for products based on a search query
 */
export const searchForProductsServer = (
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ListerDTO>(
    { url: `/aem/search`, method: 'GET', params, signal },
    { operationName: 'searchForProducts', ...options }
  );
};

export const useSearchForProductsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/aem/search`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchForProductsServer>>> = ({ signal }) =>
    searchForProductsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchForProductsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForProductsServerQueryResult = NonNullable<Awaited<ReturnType<typeof searchForProductsServer>>>;
export type SearchForProductsServerQueryError = ErrorType<SearchForProductsServer500>;

export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForProductsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForProductsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForProductsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForProductsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for products based on a search query
 */

export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForProductsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search for products based on shoplanding scanner input
 */
export const searchForFredhopperCampaignsServer = (
  params: SearchForFredhopperCampaignsServerParams,
  operationName = 'searchForFredhopperCampaigns',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<CampaignDTO>>(
    { url: `/aem/search/campaign`, method: 'GET', params, signal },
    { operationName: 'searchForFredhopperCampaigns', ...options }
  );
};

export const useSearchForFredhopperCampaignsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsServer500>,
>(
  params: SearchForFredhopperCampaignsServerParams,
  operationName = 'searchForFredhopperCampaigns',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/aem/search/campaign`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>> = ({ signal }) =>
    searchForFredhopperCampaignsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForFredhopperCampaignsServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>
>;
export type SearchForFredhopperCampaignsServerQueryError = ErrorType<SearchForFredhopperCampaignsServer500>;

export function useSearchForFredhopperCampaignsServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsServer500>,
>(
  params: SearchForFredhopperCampaignsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForFredhopperCampaignsServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsServer500>,
>(
  params: SearchForFredhopperCampaignsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForFredhopperCampaignsServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsServer500>,
>(
  params: SearchForFredhopperCampaignsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for products based on shoplanding scanner input
 */

export function useSearchForFredhopperCampaignsServer<
  TData = Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>,
  TError = ErrorType<SearchForFredhopperCampaignsServer500>,
>(
  params: SearchForFredhopperCampaignsServerParams,
  operationName = 'searchForFredhopperCampaigns',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForFredhopperCampaignsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForFredhopperCampaignsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
